<template>
  <div class="container">
    <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
      <swiper ref="mySwiper" :options="swiperOptions" class="tabs-slider fadeUp"
      :class="animate ? 'animate' : '' ">
        <swiper-slide
          class="noto-semibold highlight-tab active"
          data-highlight="all"
          >All</swiper-slide
        >

        <swiper-slide
          class="noto-semibold highlight-tab"
          v-for="tab in itemData"
          :data-highlight="tab.id"
          :key="tab.id"
        >
          {{ tab.title }}
        </swiper-slide>
      </swiper>
    </intersect>
  </div>
</template>
<script>
import Intersect from 'vue-intersect'
export default {
  props: {
    itemData: {
      type: Array,
      require: true,
    },
  },
  components: {
    Intersect
  },
  data() {
    return {
      animate: false,
      swiperOptions: {
        speed: 800,
        spaceBetween: 40,
        watchOverflow: true,
        slidesPerView: "auto",
      },
    };
  },

  mounted() {
    this.clickTabs();
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },

  methods: {
    clickTabs: function () {
      let highlightTab = document.querySelectorAll(".highlight-tab");

      let highlightsActive = [];
      let highlightAttr;

      if (highlightTab != undefined ) {
        highlightTab.forEach(function (tab) {
          tab.onclick = function () {
            highlightsActive = [];
            highlightTab.forEach(function (tabNoActive) {
              tabNoActive.classList.remove("active");
            });
            tab.classList.add("active");

            highlightAttr = tab.getAttribute("data-highlight");

            if (highlightAttr != "all") {
              let highlightsList = document.querySelector(".highlights-list");
              let highlightBox = document.querySelectorAll(".highlights-box");

              // highlightsActive = highlightsList.querySelectorAll("[data-highlight='" + highlightAttr + "']");

              highlightBox.forEach(function (box) {
                box.getAttribute("data-highlight");
                if(box.getAttribute("data-highlight")){
                  var numbers = box
                    .getAttribute("data-highlight")
                    .match(/\d+/g)
                    .map(Number);
                  for (let i = 0; i < numbers.length; i++) {
                    if (numbers[i] === parseFloat(highlightAttr)) {
                      highlightsActive.push(box);
                    }
                  }
                }

              });

              highlightBox.forEach(function (hideBox) {
                hideBox.style.display = "none";
              });

              highlightsActive.forEach(function (activeBox) {
                activeBox.style.display = "";
              });
            } else {
              let highlightBox = document.querySelectorAll(".highlights-box");
              highlightBox.forEach(function (activeBox) {
                activeBox.style.display = "";
              });
            }
          };
        });
      }
    },
  },
};
</script>
